import React from "react";
import { ChatValidator } from "./chatValidator";

export const withChatValidation = (WrappedComponent) => {
	return class extends React.Component {
		constructor(props) {
			super(props);
			this.validator = new ChatValidator();
			this.state = {
				validation: this.validator.getValidation()
			};
		}

		validateMessage = (message) => {
			const result = this.validator.validate(message);
			this.setState({ validation: result });
			return result;
		}

		render() {
			return (
				<WrappedComponent
					{...this.props}
					validation={this.state.validation}
					validateMessage={this.validateMessage}
					validator={this.validator}
				/>
			);
		}
	};
};